import { useMemo } from 'react';
import { useLocation } from 'react-router';
import qs from 'query-string';

export function useGetQueryParams(): Record<string, any> {
  // const search = window.location.search;
  const { search } = useLocation();
  return useMemo(() => qs.parse(search, { parseBooleans: true }), [search]);
}
